export enum EvaluationSearchEnum {
    Blank = "Blank",
    NeedSupportEva = "Need Support Eva",
    NeedManagerEva = "Need Manager Eva",
    NeedBrokerEva = "Need Broker Eva",
    EvaComplete = "Eva Completed"
}